import { ensureAll } from '../store/driversSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';



function DriverSelect({ innerRef, ...props }) {
    const dispatch = useDispatch();
    const _drivers = useSelector((state) => state.drivers.knownDrivers);
    const drivers = Object.values(_drivers).sort((a, b) => a.driver_firstname.localeCompare(b.driver_firstname));

    useEffect(() => {
        dispatch(ensureAll());
    }, []);

    return (
        <select ref={innerRef} {...props} >
            { drivers.map(driver => (!driver.driver_hidden) && (
                <option value={driver.driver_id}>{driver.driver_firstname} ({driver.driver_username})</option>
            )) }
        </select>
    );
};

export default DriverSelect;